const MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
];

function pad(value)
{
    return value < 10 ? `0${value}` : `${value}`;
}

function hour12(hours)
{
    const value = hours % 12;
    return value === 0 ? 12 : value;
}

// Supported format tokens (subset of moment's, covering every pattern in use):
// MMMM full month name, YYYY 4-digit year, YY 2-digit year, DD padded day,
// mm padded minute, h 12-hour hour (no pad), a lowercase meridiem.
const TOKENS = {
    MMMM: date => MONTHS[date.getMonth()],
    YYYY: date => `${date.getFullYear()}`,
    YY: date => `${date.getFullYear()}`.slice(-2),
    DD: date => pad(date.getDate()),
    mm: date => pad(date.getMinutes()),
    h: date => `${hour12(date.getHours())}`,
    a: date => date.getHours() < 12 ? 'am' : 'pm',
};

// Longest tokens first so YYYY wins over YY, MMMM over M, etc.
const TOKEN_PATTERN = /MMMM|YYYY|YY|DD|mm|h|a/g;

export default class DateManager
{
    static fromUnix(seconds)
    {
        return new Date(seconds * 1000);
    }

    static addWeeks(date, weeks)
    {
        const result = new Date(date.getTime());
        // setDate keeps the local wall-clock time across DST, matching moment's add().
        result.setDate(result.getDate() + weeks * 7);
        return result;
    }

    static format(date, pattern)
    {
        return pattern.replace(TOKEN_PATTERN, token => TOKENS[token](date));
    }

    static formatUnix(seconds, pattern)
    {
        return this.format(this.fromUnix(seconds), pattern);
    }
}
